// extracted by mini-css-extract-plugin
export default {"EZAddToCartAlerts__heading":"EZAddToCartAlerts-styles__EZAddToCartAlerts__heading__rfg3t","EZAddToCartAlerts__alert":"EZAddToCartAlerts-styles__EZAddToCartAlerts__alert__D4ond"};